import React from 'react';
import { sectionHeading } from '../lib/modalClasses';
import { Icon } from './Icon';
import type { IconName } from './Icon';

interface SectionHeadingProps {
  /** Material Symbol icon name */
  icon: IconName;
  children: React.ReactNode;
  className?: string;
  /**
   * Extra classes for the icon (e.g. `text-primary` to accent it orange).
   * Defaults to empty — the icon inherits the heading's muted colour. Settings
   * sections pass `text-primary` so the section icon reads as an accent.
   */
  iconClassName?: string;
}

/**
 * Section heading for modal content cards.
 *
 * Combines the `sectionHeading` class bundle with a Material Symbol icon automatically.
 * Use instead of writing the heading markup inline.
 *
 * Standard component for ALL modal section headings across admin and tenant.
 * Import from `@shared` — never implement inline.
 *
 * @example
 * <SectionHeading icon="person">Datos del cliente</SectionHeading>
 */
export default function SectionHeading({ icon, children, className = '', iconClassName = '' }: SectionHeadingProps) {
  return (
    <h3 className={`${sectionHeading} ${className}`}>
      <Icon name={icon} className={`!text-[16px] ${iconClassName}`} />
      {children}
    </h3>
  );
}
